jQuery(document).ready(function () {
    jQuery('.better-price-container a').on('click', function (e) {
      e.preventDefault(); // prevent link default behavior if needed
      jQuery('[data-modal="modal-entr_hcs_pop_up_Eh4T3H"] button').trigger('click');
    });
  });